import React from 'react'
import Header from '../../Components/Header/header';
import ImageSlider from '../../Components/ImageSlider/imageSlider';
import Reach from '../../Components/Reach/reach';
import FootPage from '../../Components/FooterPage/footPage';
import './Login.css';

export default function Login() {

  const [message, setMessage] = React.useState({
    email: "",
    password: "",
    isFriendly: false

    
})

function handleChange(event) {
  const {name, value, type, checked} = event.target
  setMessage(prevState => {
    return {
      ...prevState,
      [name]: type === "checkbox" ? checked : value
    }
  })

}
  return (
    <div className='login'>
       <Header />
      <div className='login-input'>
        <div className="login-left">
          <h4 className="login-title1">Sign In</h4>
          <p className='login-description'>Proin facilisis varius nunc. Curabitur eros risus, ultrices et dui ut, luctus accumsan nibh. Fusce convallis sapien placerat tellus suscipit vehicula.fermentum. Curabitur pellentesque</p>
          <div className='login-ask'>
            <p className='login-acct'>Don’t have account yet?</p>
            <p className='login-acct2'><a href="/signup" className='login-link'>Create an account</a></p>
          </div>
        </div>
      <div className='login-right'>
      <form action='/action_page.php'>
        <label for='email'>Email</label>
       <input
        type='text'
        placeholder= 'Email'
        className='form-input-login'
        name='fullname'
        value={message.email}
        onChange={handleChange}
      />
         <label for='password'>Password</label>
       <input
        type='password'
        placeholder='password'
        className='form-input-login'
        name='email'
        value={message.password}
        onChange={handleChange}
      />
       <input
       type='submit' 
       className='form-button-login' 
       value='SIGN IN'
       />
       
       <input
       type='checkbox' 
       id="isFriendly"
       checked={message.isFriendly}
       onChange={handleChange}
       name='isFriendly'
       />
       <label htmlFor='isFriendly'>Remember me</label>
       
       </form>
       <a href="#" className='forgot'>Forgot Password?</a>
      </div>

      </div>
      <div className="slider-login">
        <ImageSlider />
        </div>
        <Reach />
        <div className="footPage">
          <FootPage />
        </div>
    </div>
  )
}
